import { render, staticRenderFns } from "./DashboardV2Component.vue?vue&type=template&id=7d456ca8&"
import script from "./DashboardV2Component.vue?vue&type=script&lang=js&"
export * from "./DashboardV2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports